module.exports = __webpack_public_path__ + "img/CarrierEnv.9038451c.svg";